class FeaturedCollection {
    constructor(container) {
        this.container = container;
        this.autoplayEnabled = false;
        this.autoplayCarouselSpeed = 5 * 1000;
        this.splideInstance = null;
        this.init();
    }

    init() {
        this.handleSplideSlider(this.container);
    }

    handleSplideSlider(container) {
        const featuredCollectionSlider = container.querySelector('[featured-collection-slider]');

        if (featuredCollectionSlider) {
            this.splideInstance = new Splide(featuredCollectionSlider, {
                type: 'slide',
                perPage: 6,
                perMove: 1,
                mobileFirst: true,
                autoplay: this.autoplayEnabled,
                interval: this.autoplayCarouselSpeed,
                arrows: false,
                pagination: false,
                speed: 1000,
                trimSpace: 'move',
                gap: 40,
                breakpoints: {
                    767: {
                        perPage: 1,
                        centerMode: true,
                        variableWidth: true,
                    },
                },
            }).mount();
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const featuredCollectionSection = document.querySelector('[featured-collection]');
    if (featuredCollectionSection) {
        const featuredCollection = new FeaturedCollection(featuredCollectionSection);

        const btnNext = document.getElementById('next-button');
        const btnPrev = document.getElementById('previous-button');
        const btnNextMobile = document.getElementById('next-button-mobile');
        const btnPrevMobile = document.getElementById('previous-button-mobile');

        btnNext.addEventListener('click', () => {
            featuredCollection.splideInstance.go('+1');
        });

        btnPrev.addEventListener('click', () => {
            featuredCollection.splideInstance.go('-1');
        });

        btnNextMobile.addEventListener('click', () => {
            featuredCollection.splideInstance.go('+1');
        });

        btnPrevMobile.addEventListener('click', () => {
            featuredCollection.splideInstance.go('-1');
        });
    }
});
